import { Suspense, lazy } from "react";
import componentLoader from "../utils/componentLoader";

const LottieLoading = lazy(() => componentLoader(() => import(/* webpackPreload: true */ "./lottieLoading"), 3));

const Loading = () => (
  <Suspense fallback={"Loading ..."}>
    <LottieLoading />
  </Suspense>
);

export default Loading;
